exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__counter___3iPmL{color:#5a6872;font-size:.75rem;margin-top:-1rem;text-align:right}", ""]);

// Exports
exports.locals = {
	"counter": "styles__counter___3iPmL"
};